import {assertAndContinue} from 'Asserts';
import {DataPointColumnsToDataType} from 'data-frames/DataFrameTypes';

/**
 * Assert that the given columnTypes and rows objects match in terms of definition.
 *
 * If a column is defined in columnTypes, then it should be defined in every point in the rows array. The same
 * applies to the opposite - if a column is defined in any point, it should be defined in columnTypes and every
 * other point. This function asserts that these conditions are true.
 *
 * @deprecated This function is implemented with an old version of the DataFrame interface. New uses are discouraged,
 * instead the function should be converted to use the new interface.
 */
// TODO(BNCH-24546): Remove or reimplement data frame utils that use DeprecatedDataFrame
export default function assertWellFormedColumn<DataPoint>(
  {
    columnTypes,
    rows,
  }: {
    columnTypes: DataPointColumnsToDataType<DataPoint>;
    rows: Array<DataPoint>;
  },
  columnName: keyof DataPoint & string
): void {
  if (rows.some((row) => row[columnName] != null)) {
    assertAndContinue(
      columnTypes[columnName] !== undefined,
      `Expected "${columnName}" columnType to be specified if some rows have "${columnName}" specified`
    );
  }

  if (columnTypes[columnName] !== undefined) {
    assertAndContinue(
      rows.every((row) => row[columnName] !== undefined),
      `Expected every row to have "${columnName}" specified if it is specified in columnTypes`
    );
  }
}
